import { styled } from "styled-components";
import DatabaseListHead from "./database-list-head/DatabaseListHead";
import DatabaseListBody from "./database-list-body/DatabaseListBody";
import {
  DatabaseType,
  FileType,
  IDataSource,
  IDataSourceFilter,
  IDataSourceFilterChangeValue,
  IPaginationFilters,
  ISearchPayload,
  ITopics,
  QUERIES,
  getDataSources,
  getRelatedCacheKey,
  getTopics,
} from "@dataone/lib";
import { MutableRefObject, useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import DatabaseTopics from "./database-topics/DatabaseTopics";

interface DatabasesProps {
  selectedDB: IDataSource | null;
  stepRef3: MutableRefObject<null>;
  stepRef4: MutableRefObject<null>;
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedDB: React.Dispatch<React.SetStateAction<IDataSource | null>>;
  setResponse: React.Dispatch<React.SetStateAction<Partial<ISearchPayload>>>;
  setShowResponse: React.Dispatch<React.SetStateAction<boolean>>;
  setShowComponents: React.Dispatch<React.SetStateAction<boolean>>;
}

const Databases = ({
  selectedDB,
  stepRef3,
  stepRef4,
  isOpen,
  setOpen,
  setSelectedDB,
  setResponse,
  setShowResponse,
  setShowComponents,
}: DatabasesProps) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const [datasetsFilters, setDatasetsFilters] = useState<
    IPaginationFilters<IDataSourceFilter, IDataSource>
  >({
    body: {
      displayName: "",
      dataSourceInternalTypes: [
        DatabaseType.MYSQL,
        DatabaseType.POSTGRESQL,
        DatabaseType.SQLSERVER,
        DatabaseType.SAGE,
        DatabaseType.SAP,
        FileType.EXCEL,
        FileType.CSV,
      ],
    },
    pageNo: 0,
    pageSize: 50,
    beforeDate: new Date(),
    sortBy: "createdAt",
    sort: "DESC",
  });

  const {
    data: datasources,
    isLoading,
    refetch: refetchDatasets,
  } = useQuery({
    queryKey: [QUERIES.DATA_SETS, datasetsFilters],
    queryFn: () => getDataSources(datasetsFilters),
  });

  const handleFilterChange = (object: IDataSourceFilterChangeValue) => {
    if (object) {
      const [key, value] = Object.entries(object)[0];
      setDatasetsFilters((prev) => ({
        ...prev,
        [key]: value,
        pageNo:
          key === "pageNo"
            ? value
            : ["body", "sortBy"].includes(key)
            ? 0
            : prev.pageNo,
        sort:
          key === "sortBy" ? (value === "name" ? "ASC" : "DESC") : prev.sort,
      }));
    }
  };

  const queryClient = useQueryClient();
  const handleActionSucceededUpdates = () => {
    handleFilterChange({ beforeDate: new Date() });
    const keys = getRelatedCacheKey(queryClient, [QUERIES.DATA_SETS]);
    keys.forEach((key) => {
      queryClient.removeQueries(key);
    });
  };

  const [topics, setTopics] = useState<ITopics[]>([]);

  const { mutate: fetchTopics } = useMutation(getTopics);

  useEffect(() => {
    if (
      selectedDB &&
      selectedDB.id &&
      selectedDB.dataSourceType === "DATABASE"
    ) {
      fetchTopics(selectedDB.id, {
        onSuccess: (data) => {
          setTopics(data);
        },
      });
    }
  }, [selectedDB, fetchTopics]);

  return (
    <StyledDatabases>
      <div>
        <DatabaseListHead
          selectedDB={selectedDB}
          setModalOpen={setModalOpen}
          isModalOpen={isModalOpen}
          datasources={datasources}
        />
      </div>
      <div className="topics">
        <DatabaseTopics selectedDB={selectedDB} />
      </div>
      {/* <StyledTopics
        exist={
          selectedDB !== null && selectedDB.dataSourceType === "DATABASE"
            ? true
            : false
        }
      >
        {topics.length === 0 ? (
          <DatabaseTopics
            title="No topic"
            description="Sorry, but no topics were found for the specified database. Please try connecting again to the database."
          />
        ) : (
          topics.map((topic, index) => (
            <DatabaseTopics
              key={index}
              title={topic.title}
              description={topic.description}
            />
          ))
        )}
      </StyledTopics> */}
      <StyledBody>
        <DatabaseListBody
          selectedDB={selectedDB}
          stepRef3={stepRef3}
          stepRef4={stepRef4}
          isOpen={isOpen}
          setOpen={setOpen}
          setSelectedDB={setSelectedDB}
          setResponse={setResponse}
          setShowResponse={setShowResponse}
          setShowComponents={setShowComponents}
          isModalOpen={isModalOpen}
          setModalOpen={setModalOpen}
          datasources={datasources}
          isLoading={isLoading}
          onCreateSuccess={handleActionSucceededUpdates}
          refetchDatasets={refetchDatasets}
        />
      </StyledBody>
    </StyledDatabases>
  );
};

export default Databases;

const StyledBody = styled.div`
  // height: 200px;
  // overflow-y: auto;
  // overflow-y: hidden;
`;
const StyledDatabases = styled.div`
  width: 580px;
  // padding: 0px 20px 0px 9px;
  .topics {
    position: relative;
    z-index: 1;
    overflow: hidden;

    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 0;
      height: 100%;
      z-index: 2;
    }

    &:before {
      left: -5px;
      background: linear-gradient(to left, rgba(255, 255, 255, 0), #ffffff);
      width: 20px;
    }

    &:after {
      right: 0;
      background: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff);
      width: 20px;
    }
  }
`;
